import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils';
import { type YJSChangeHandler } from '../../types';

export const setValueCommentThreadCommentCount: YJSChangeHandler<
  DatabaseChangeType.SET_VALUE_COMMENT_THREAD_COMMENT_COUNT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.setCommentThreadCommentCount(
      getValueId(change.entryId, change.fieldId),
      change.threadId,
      change.commentCount
    );
  });
};
